import { LATEST_PRIVACY_POLICY } from '@Constants/legalDocumentVersions';
import { UserText } from '@Constants/UserText';
import { useAcceptPrivacyPolicy } from '@Hooks/Permissions';
import { useLogout } from '@Hooks/useMsal';
import { Button, FlexRow, Modal } from '@synqo/frontend-component-library';
import { FC } from 'react';
import { Link } from 'react-router';

interface AcceptLegaleseProps {
    refetchProfile: () => void;
}

export const AcceptUserLegalese: FC<AcceptLegaleseProps> = ({ refetchProfile }) => {
    const logout = useLogout();
    const { mutateAsync: acceptPrivacyPolicy } = useAcceptPrivacyPolicy();

    return (
        <Modal isOpen={true} withoutCloseButton={true} onClose={() => {}} title={'Zustimmung zur Datenschutzerklärung'}>
            <p>
                Um {UserText.APP_NAME} nutzen zu können, muss unserer{' '}
                <Link
                    className="text-(--mantine-color-text-5) hover:text-(--mantine-color-text-7) underline"
                    to={'/datenschutzerklaerung.pdf'}
                    target="_blank"
                >
                    Datenschutzerklärung
                </Link>{' '}
                zugestimmt werden.
            </p>

            <FlexRow justify={'space-between'} className={'pt-5'}>
                <Button
                    variant={'warning'}
                    onClick={logout}
                    appearance={'filled'}
                    label={'Nicht zustimmen (ausloggen)'}
                >
                    Nicht zustimmen (ausloggen)
                </Button>
                <Button
                    variant={'success'}
                    appearance={'filled'}
                    onClick={async () => {
                        await acceptPrivacyPolicy(LATEST_PRIVACY_POLICY);
                        refetchProfile();
                    }}
                    label={'Zustimmen'}
                >
                    Zustimmen
                </Button>
            </FlexRow>
        </Modal>
    );
};
